/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */


export let MDTimezones = function() {

	var mj_timezones = {
		'-12:00,0': 'Etc/GMT-12',
		'-11:00,0': 'Etc/GMT-11',
		'-10:00,0': 'US/Hawaii',
		'-09:00,1': 'US/Alaska',
		'-08:00,1': 'US/Pacific',
		'-07:00,0': 'US/Arizona',
		'-07:00,1': 'US/Mountain',
		'-06:00,0': 'Canada/Saskatchewan',
		'-06:00,1': 'US/Central',
		'-05:00,0': 'US/Indiana-Starke',
		'-05:00,1': 'US/Eastern',
		'-04:00,1': 'Canada/Atlantic',
		'-04:00,0': 'America/Caracas',
		'-03:30,1': 'Canada/Newfoundland',
		'-03:00,1': 'America/Godthab',
		'-03:00,0': 'America/Argentina/Buenos_Aires',
		'-02:00,1': 'Atlantic/South_Georgia',
		'-01:00,1': 'Atlantic/Azores',
		'-01:00,0': 'Atlantic/Cape_Verde',
		'00:00,0': 'Africa/Casablanca',
		'00:00,1': 'Europe/Dublin',
		'+01:00,1': 'Europe/Berlin',
		'+01:00,0': 'Africa/Algiers',
		'+02:00,1': 'Europe/Athens',
		'+02:00,0': 'Africa/Harare',
		//'+03:00,1': 'Europe/Moscow',
		'+03:00,0': 'Asia/Kuwait',
		'+03:30,0': 'Asia/Tehran',
		'+04:00,0': 'Europe/Moscow',		// since Mar/27, 2011
		//??//'+04:00,0': 'Asia/Muscat',
		'+04:00,1': 'Asia/Baku',
		'+04:30,0': 'Asia/Kabul',
		'+05:00,1': 'Asia/Yekaterinburg',
		'+05:00,0': 'Asia/Karachi',
		'+05:30,0': 'Asia/Kolkata',
		'+05:45,0': 'Asia/Katmandu',
		'+06:00,0': 'Asia/Dhaka',
		'+06:00,1': 'Asia/Almaty',
		'+06:30,0': 'Asia/Rangoon',
		'+07:00,1': 'Asia/Krasnoyarsk',
		'+07:00,0': 'Asia/Bangkok',
		'+08:00,0': 'Asia/Hong_Kong',
		'+08:00,1': 'Australia/Perth',
		'+09:00,1': 'Asia/Yakutsk',
		'+09:00,0': 'Asia/Seoul',
		'+09:30,0': 'Australia/Darwin',
		'+09:30,1': 'Australia/Adelaide',
		'+10:00,0': 'Australia/Brisbane',
		'+10:00,1': 'Australia/Melbourne',
		'+11:00,0': 'Asia/Magadan',
		'+12:00,1': 'Pacific/Auckland',
		'+12:00,0': 'Pacific/Fiji',
		'+13:00,0': 'Pacific/Tongatapu',
	};

	function fmt_timezone( offset_hours, dst ) {
		var int_hours = parseInt( offset_hours, 10 ),
			int_minutes = parseInt( ( offset_hours - int_hours ) * 60, 10 ),
			display_hours = int_hours == 0
				? '00'
				: ( int_hours > 0
					? ( int_hours <  10 ? '+0' + int_hours : '+' + int_hours )
					: ( int_hours > -10 ? '-0' + Math.abs( int_hours ) : int_hours )
				);
		return display_hours + ':' + ( int_minutes < 10 ? '0' + int_minutes : int_minutes ) + ',' + dst;
	}

	function xtr_timezone( str ) {
		var tz_id_re = /^([+-]?)(\d{2}):(\d{2}),([01])$/,
			xtr = tz_id_re.exec(str),
			ofs;
		if( xtr===null ) return null;
		ofs = parseInt(xtr[2],10) + parseInt(xtr[3],10) / 60.0;
		if( xtr[1]=='-' ) ofs = -ofs;
		return [ ofs, parseInt(xtr[4],10) ];
	}

	function xtr_timezone1( str ) {
		var tz_id_re = /^([+-]?)(\d{2}):(\d{2})$/,
			xtr = tz_id_re.exec(str),
			ofs;
		if( xtr===null ) {
			var tz_id_re2 = /^([+-]?)(\d{2})$/,
				xtr2 = tz_id_re2.exec(str);
			if( xtr2===null ) {
				return null;
			}
			ofs = parseInt(xtr2[2],10);
			if( xtr2[1]=='-' ) ofs = -ofs;
			return [ofs,0];

		}
		ofs = parseInt(xtr[2],10) + parseInt(xtr[3],10)/60.0;
		if( xtr[1]=='-' ) ofs = -ofs;
		return [ofs,0];
	}


	var mj_timezone_info = null,
		mj_timezone_offset = 0,
		mj_timezone_offset_hours = 0,
		mj_timezone_offset_minutes = 0,
		mj_timezone_id = '00:00,0',
		mj_timezone_name = mj_timezones[mj_timezone_id];


	function detect() {
		//console.log({fn:'detect'});
		var now = new Date(),
			// find std/winter time offset
			jan1 = new Date( now.getFullYear(), 0,1,0,0,0,0 ),
			tmp1 = jan1.toGMTString(),
			jan2 = new Date( tmp1.substring(0,tmp1.lastIndexOf(' ')) ),
			std_time_offset = parseInt( (jan1-jan2)/(1000*60*60), 10 ),
			// find dst/summer time offset
			june1 = new Date( now.getFullYear(), 6,1,0,0,0,0 ),
			tmp2 = june1.toGMTString(),
			june2 = new Date( tmp2.substring(0,tmp2.lastIndexOf(' ')) ),
			daylight_time_offset = parseInt( (june1-june2)/(1000*60*60), 10 ),
			// is dst observed at all?
			dst = std_time_offset==daylight_time_offset ? 0 : 1;
		return [ std_time_offset, dst ];
	}


	function is_dst_in_effect( tz_info, at_date ) {
		//console.log({fn:'is_dst_in_effect',tz_info,at_date});
		if( tz_info && tz_info[1] ) {
			var tmp = at_date.toGMTString();
			var gmt_at_date = new Date( tmp.substring(0,tmp.lastIndexOf(' ')) );
			var cur_time_offset = parseInt( (at_date-gmt_at_date) / (1000*60*60), 10 );
			return tz_info[0] != cur_time_offset;
		}
		return false;
	}


	function init( tz ) {
		//console.log({fn:'tz init',tz});
		if( tz in mj_timezones ) {
			// explicitely selected by user
			mj_timezone_info = xtr_timezone(tz);
		}
		if( mj_timezone_info===null ) {
			// auto detect
			mj_timezone_info = detect();
		}
		var dst_is_in_effect_now = is_dst_in_effect(mj_timezone_info,new Date());
		mj_timezone_offset = mj_timezone_info[0] + ( dst_is_in_effect_now ? 1 : 0 );
		mj_timezone_offset_hours = parseInt( mj_timezone_offset, 10 );
		mj_timezone_offset_minutes = ( mj_timezone_offset - mj_timezone_offset_hours ) * 60;
		mj_timezone_id = fmt_timezone( mj_timezone_info[0], mj_timezone_info[1] );
		mj_timezone_name = ( mj_timezone_id in mj_timezones ) ? mj_timezones[mj_timezone_id] : 'unknown';
	}


	//Date & Time helper functions
	function xpl_datetime( d ) {
		var l = d ? d.length : 0;
		if( l >= 19 ) {			// YYYY-MM-DD HH:mm:ss
			return [
				parseInt(d.substr(0,4),10)||0,
				parseInt(d.substr(5,2),10)||0,
				parseInt(d.substr(8,2),10)||0,
				parseInt(d.substr(11,2),10)||0,
				parseInt(d.substr(14,2),10)||0,
				parseInt(d.substr(17,2),10)||0,
			];
		} else if( l>=10 ) {	// YYYY-MM-DD
			return [
				parseInt(d.substr(0,4),10)||0,
				parseInt(d.substr(5,2),10)||0,
				parseInt(d.substr(8,2),10)||0,
				0,0,0,
			];
		} 				// -invalid-
		return [ 0,0,0, 0,0,0 ];
	}


	function mj_datetime_to_date_object( d ) {
		return new Date( d[0],d[1]-1,d[2], d[3],d[4],d[5] );
	}

	/* not used yet ..
	/// get date object from string "YYYY-MM-DD HH:mm:ss"
	function mj_datetime_string_to_date_object( s ) {
		var d = xpl_datetime(s);
		if( d[0]==0 ) return false; // invalid datetime string input
		return mj_datetime_to_date_object(d);
	}
	*/

	function mj_date_object_to_datetime_string( d ) {
		// return sprintf( '%04d-%02d-%02d %02d:%02d:%02d', d.getFullYear(), d.getMonth()+1,d.getDate(), d.getHours(),d.getMinutes(),d.getSeconds() );
		return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2)+' '+('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2)+':'+('0'+d.getSeconds()).slice(-2);
	}


	function mj_tz_offset_at_date( tz_info, at_date ) {
		var is_dst_in_effect_at_date = is_dst_in_effect(tz_info,at_date),
			offs = tz_info[0] + ( is_dst_in_effect_at_date ? 1 : 0 ),
			offs_hours = parseInt(offs,10),
			offs_minutes = (offs-offs_hours) * 60;
		return [offs_hours,offs_minutes];
	}

	function datetime_tzoned2utc( d, tz_spec ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';
		var at_date = mj_datetime_to_date_object(d);

		// so, data-implied TZ will always have same DST=0 ?
		// -> not quite correct !
		// -> but what is be the correct way here anyway ???
		var tz_info = xtr_timezone1(tz_spec);

		var actual_offs = mj_tz_offset_at_date(tz_info,at_date);
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]-actual_offs[0],d[4]-actual_offs[1],d[5] ) );
	}

	function datetime_any2local( d ) {
		var l = d ? d.length : 0;
		if( l <= 19 ) {										// "YYYY-MM-DD HH:mm:ss" or even "YYYY-MM-DD"
			// just expect it as being specified in utc... and convert it to local time now ...
			return datetime_utc2local(d);
		}
		//      "YYYY-MM-DD HH:mm:ss.xxxxx+ZZ"
		//   or "YYYY-MM-DD HH:mm:ss.xxxxx"
		//   or "YYYY-MM-DD HH:mm:ss+ZZ"
		//   or "YYYY-MM-DD HH:mm:ss+ZZ:zz"
		//   or "YYYY-MM-DD HH:mm:ss-ZZ"
		//   or "YYYY-MM-DD HH:mm:ss-ZZ:zz"
		// e.g. "2015-11-08 11:49:26.76923+00"
		var t = d.substr(0,19);
		var r = d.substr(19);							// => ".76923+ZZ"
		if( r.length>1 && r[0]=='.' ) {
			r = r.substr(1);							// =>  "76923+ZZ"
			while( r.length>0 && !(r[0]=='-'||r[0]=='+') ) r = r.substr(1);
			// =>  "+ZZ"
		}
		if( r.length>1 && (r[0]=='+'||r[0]=='-') ) {
			var tz_spec = r;
			var d_utc = datetime_tzoned2utc(t,tz_spec);
			return datetime_utc2local(d_utc);
		}
		return datetime_utc2local(t);
	}



	function datetime_utc2local( d ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';
		var at_date = mj_datetime_to_date_object(d),
			actual_offs = mj_tz_offset_at_date(mj_timezone_info,at_date);
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]+actual_offs[0],d[4]+actual_offs[1],d[5] ) );
	}


	function datetime_local2utc( d ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';
		var at_date = mj_datetime_to_date_object(d),
			actual_offs = mj_tz_offset_at_date(mj_timezone_info,at_date);
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]-actual_offs[0],d[4]-actual_offs[1],d[5] ) );
	}


	return {

		init: init,
		detect: detect,
		fmt_timezone: fmt_timezone,

		getTimezones: function() {
			return mj_timezones;
		},
		getTimezoneName: function() {
			return mj_timezone_name;
		},
		getTimezoneOffsetHM: function() {
			return [mj_timezone_offset_hours,mj_timezone_offset_minutes];
		},

		xpl_datetime: xpl_datetime,

		mj_datetime_to_date_object: mj_datetime_to_date_object,
		mj_date_object_to_datetime_string: mj_date_object_to_datetime_string,

		datetime_any2local: datetime_any2local,
		datetime_utc2local: datetime_utc2local,
		datetime_local2utc: datetime_local2utc,
	};

}(); // function MDTimezones

